import * as React from 'react';
import { styled } from '@mui/material/styles';
import { blue } from '@mui/material/colors';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
    AccordionSummaryProps,
    accordionSummaryClasses,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { Stack, Typography, FormControlLabel } from '@mui/material';
import { BlueSwitch } from './StyledSwitches';

export const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

export const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
        transform: 'rotate(90deg)',
    },
    [`& .${accordionSummaryClasses.content}`]: {
        marginLeft: theme.spacing(1),
    },
    ...theme.applyStyles('dark', {
        backgroundColor: 'rgba(255, 255, 255, .05)',
    }),
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
}));

/*
const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        if (newExpanded) setExpanded(panel);
};
*/
export const ExpandControlledAccordion = ({ expanded, exName, handleChange, children }:
    {
        expanded: boolean,
        exName: string,
        children: React.ReactNode[],
        handleChange: (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => void
    }) => {
    const id = React.useId();       // generate a unique id for the summary to avoid duplicate ids in the DOM

    return <Accordion id={id} expanded={expanded} onChange={handleChange(exName)}>
        {children}
    </Accordion>
};

/*
const handleChangeSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
};
*/
export const SwitchedAccordionSummary = ({ acName, handleswitchChange, checked }: {
    acName: string;
    checked: boolean;
    handleswitchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
    const id = React.useId();       // generate a unique id for the summary to avoid duplicate ids in the DOM

    return <AccordionSummary id={id}>
        <Stack width={'100%'} direction={'row'} justifyContent={'space-between'}>
            <Typography color={blue[600]} component="span">{acName}</Typography>
            <FormControlLabel 
                label={''} 
                control={<BlueSwitch onChange={handleswitchChange} checked={checked} />}
                onClick={(event) => event.stopPropagation()} // don't let the switch change event bubble up to the accordion summary, which would cause the accordion to expand/collapse
            />
        </Stack>
    </AccordionSummary>
};